import i18n from '@locale/i18n';

export interface ILive {
	link: string;
	name: string;
	icon?: string;
}

export const lives: ILive[] = [
	{
		link: 'https://newlive.nasimrezvan.com/hls/Rawzeh-ye-Monavvareh/index.m3u8',
		// link: 'https://stream01.nasimrezvan.com/hls/nCqGTHytkVFziVPWBLqkdQYK/index.m3u8',
		name: i18n.t('rozetv')
	},
	{
		link: 'https://newlive.nasimrezvan.com/hls/Shrine-Programs/index.m3u8',
		// link: 'https://stream01.nasimrezvan.com/hls/goHbjWCkGYDnCbktiPWdmxco/index.m3u8',
		name: i18n.t('razavitv')
	},
	{
		link: 'https://newlive.nasimrezvan.com/hls/News-Segment/index.m3u8',
		// link: 'https://stream01.gaplication.com/hls/Razavi1400bdisosvxpevqy/index.m3u8',
		// link: 'https://stream01.nasimrezvan.com/hls/uGEFhbtuYfKoFCaBwEkkVxwV/index.m3u8',
		name: i18n.t('shamstv')
	}
];
